module.exports = __webpack_public_path__ + "img/scene2-2.d2032f90.jpg";